const TABLETYPE = {
  MERCHANT: 0,
  LIQUIDITY: 1,
  SUBACCOUNT: 2,
  CURRENCY: 3,
  NETWORK: 4
};

export { TABLETYPE };
